import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import fetchData from "verticales/FetchData";
import AppLoading from "verticales/AppLoading.tsx";
import iconUsuario from "assets/images/icons/icono_usuario.ico";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "informes";

function UsuariosConectados() {
  const [numeroUsuarios, setNumeroUsuarios] = useState({});
  const [blocking, setBlocking] = React.useState(false);
  useEffect(() => {
    const catData = async () => {
      setBlocking(true);
      const data = await fetchData(url, context, { action: "dashboard-usuarios-conectados" });
      console.log("dataUsuarios....", data);
      if (data) {
        const obj = data.rows[0];
        setNumeroUsuarios(obj);
      } else {
        console.log("Error en fetch");
      }
      setBlocking(false);
    };
    catData();
  }, []);
  return (
    <Grid item xs={12} md={6} lg={3}>
      <MDBox mb={1.5}>
        {blocking ? (
          <AppLoading titleCustom={"Usuarios Conectados"} />
        ) : (
          <ComplexStatisticsCard
            color="dark"
            icon={<img src={iconUsuario} />}
            title="Usuarios Conectados"
            count={numeroUsuarios.usuarios}
            percentage={{
              color: "success",
              amount: numeroUsuarios["instance_count"],
              label: "Instancias con usuarios activos",
            }}
          />
        )}
      </MDBox>
    </Grid>
  );
}

export default UsuariosConectados;
